module.exports = __webpack_public_path__ + "static/media/loginImage.fbb031ef.svg";